/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Bondsmith Savings Exchange Bank Portal APIs
 * OpenAPI spec version: 0.1
 */

export type CustomerAccountInsightsPaginatedProperty =
  typeof CustomerAccountInsightsPaginatedProperty[keyof typeof CustomerAccountInsightsPaginatedProperty];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CustomerAccountInsightsPaginatedProperty = {
  CLIENT_ID: 'CLIENT_ID',
  PRODUCT_ID: 'PRODUCT_ID',
  PRODUCT_TYPE: 'PRODUCT_TYPE',
  PRODUCT_NAME: 'PRODUCT_NAME',
  GROSS_RATE: 'GROSS_RATE',
  START_DATE: 'START_DATE',
  CUSTOMER_PRODUCT_ACCOUNT_BALANCE: 'CUSTOMER_PRODUCT_ACCOUNT_BALANCE',
} as const;
